import { NavLink } from 'react-router-dom';

import { Menu, MenuItem } from '@mui/material';

import type { HeaderMenuItemValue } from '@system/app/store/mainMenu.store';

type HeaderSubMenuProps = {
  items: HeaderMenuItemValue[];
  onClose: () => void;
  anchorEl?: null | HTMLElement;
};

export const HeaderSubMenu = (props: HeaderSubMenuProps) => {
  const { items, anchorEl, onClose } = props;
  const open = Boolean(anchorEl);

  if (!open) {
    return null;
  }
  return (
    <Menu
      id="header-sub-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            mt: 1.9,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
            backgroundColor: p => p.palette.primary.main,
            clipPath: 'inset(0px -12px -20px -20px)',
          },
        },
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      {items.map((item, index) => (
        <MenuItem
          key={index}
          component={NavLink}
          to={item.path}
          onClick={onClose}
          sx={{
            color: '#fff',
            fontSize: '1.1rem',
          }}
        >
          {item.title}
        </MenuItem>
      ))}
    </Menu>
  );
};
